/** @format */
import angular from 'angular';
import { ConfigService } from './config.service';

export const configModule = 'sis-common.config';

(function () {
    angular.module(configModule, []).factory('configService', () => new ConfigService());
})();
